import api from '../auth';
const slug = 'api/tip_trosilas/';

const TipTrosilaService = () => {
    const getTipTrosilas = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getTipTrosilasLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getTipTrosila = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deleteTipTrosila = (id) => {
        return api
            .delete(slug + `tip_trosila/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createTipTrosila = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateTipTrosila = (id, data) => {
        return api.put(slug + `tip_trosila/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyTipTrosila = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    return {
        getTipTrosilas,
        getTipTrosilasLazy,
        getTipTrosila,
        deleteTipTrosila,
        createTipTrosila,
        updateTipTrosila,
        getOptions,
        copyTipTrosila
    };
};

export default TipTrosilaService;
